import type { EmployeeComplianceSummary } from '../types/compliance'

const COMPLIANCE_FIELDS = [
  {
    name: 'compliance_medical_insurance',
    title: 'Медицинский полис',
    complianceType: 'medical_insurance',
  },
  {
    name: 'compliance_patent',
    title: 'Патент/разрешение',
    complianceType: 'patent',
  },
  {
    name: 'compliance_receipt',
    title: 'Чеки',
    complianceType: 'receipt',
  },
] as const

export function injectComplianceFieldsIntoSchema(
  resultSchema: Record<string, any>,
  formDataObj: Record<string, unknown>,
  employeeId?: number | string,
): void {
  if (!employeeId || employeeId === 'new' || !resultSchema?.properties) {
    return
  }

  for (const field of COMPLIANCE_FIELDS) {
    if (!resultSchema.properties[field.name]) {
      resultSchema.properties[field.name] = {
        title: field.title,
        type: 'string',
        view: { name: 'hr-employee-compliance' },
        options: { complianceType: field.complianceType },
      }
    }
    if (formDataObj[field.name] === undefined) {
      formDataObj[field.name] = null
    }
  }

  if (!resultSchema.groups) {
    resultSchema.groups = {}
  }

  const groupEntry = Object.entries(resultSchema.groups).find(([, group]) => {
    const fields = (group as { fields?: string[] })?.fields ?? []
    return (
      fields.includes('register_expiry_date') ||
      fields.includes('foreign_passport') ||
      fields.includes('passport_expiry_date')
    )
  })

  if (!groupEntry) {
    return
  }

  const [, group] = groupEntry
  const fields = (group as { fields: string[] }).fields
  const insertAfter = ['register_expiry_date', 'passport_expiry_date', 'foreign_passport'].find(name =>
    fields.includes(name),
  )
  const insertIndex = insertAfter ? fields.indexOf(insertAfter) + 1 : fields.length
  let cursor = insertIndex

  for (const field of COMPLIANCE_FIELDS) {
    if (!fields.includes(field.name)) {
      fields.splice(cursor, 0, field.name)
      cursor += 1
    }
  }
}

export type { EmployeeComplianceSummary }
